module.exports = __webpack_public_path__ + "static/media/intro_bg.02d8b1c1.jpeg";